<template>
  <router-view></router-view>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'App',
  components: {
   
  }
}
</script>


<style lang="less">
  @import url('./components/common/style/common.less');
  html,body,#app,.el-container{
    width: 100%;
    height: 100%;
  }
  .el-container{
    height: calc(100vh - 76px);
    overflow-y: hidden;
    background: #F5F8FC;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100vh;
    height: 100vh;
    overflow: hidden;
    font-family: PingFang SC, MicrosoftYaHei, Arial, sans-serif;
  }
  a{
    display: block;
    text-decoration: none;
  }
</style>
